import HeaderFilter from '../../../components/HeaderFilter';
import { useAuthStore } from '../../../store';
import DepartmentTable from './DepartmentTable';
import DepartmentForm from './DepartmentForm';

const DepartmentPage = () => {
  const api = '/hr/departments';
  const moduleName = 'Department';
  const moduleCode = 'DEPT';
  const { user } = useAuthStore();
  const userModuleAccess = user?.moduleAccess?.find(
    (item) => item.module.code === moduleCode,
  );
  return (
    <>
      <div className={'page-wrapper'}>
        <HeaderFilter />
        <DepartmentTable
          api={api}
          userRole={user?.role}
          moduleName={moduleName}
          userModuleAccess={userModuleAccess}
        />
        <DepartmentForm api={api} moduleName={moduleName} />
      </div>
    </>
  );
};

export default DepartmentPage;
